// TRM 7.3 / 7.1 Exceptions Table: at reassessment, prior answers are shown grayed out and
// must be reconfirmed per screen ("Are all of the answers shown above still accurate?").

// Must be answered fresh at reassessment, never reconfirmed screen-wide (Smoking, Swallowing/NPO, Family Support per TRM 7.3;
// Nutrition and oxygen_in_home share those screens, so they are asked fresh too)
export const REASSESS_FRESH_QUESTIONS = ['smoking', 'chewingSwallowing', 'npoInstruction', 'currentHelpers', 'currentFamilySupportLevel', 'oxygen_in_home', 'nutrition'];

// Answered in the current session, or still locked to the prior quote's values: no screen-level confirmation
export const REASSESS_SKIP_CONFIRM = [
  'languagePreference', 'isStaff', 'staffMemberName', 'referralSourceName', 'reassessmentQuote',
  'callerName', 'callerEmail', 'callerPhoneNumber', 'relationship', 'decisionMaker', 'hasCallerEmail',
];

const getQuestionKey = (answerKey: string) => answerKey.split('/')[2] || '';

// Drop fresh-only answers (incl. their follow-ups / Other inputs) so they are not carried forward
export const removeFreshAnswers = (answers: Record<string, any>) => {
  const result = { ...answers };
  Object.keys(result).forEach((answerKey) => {
    const qKey = getQuestionKey(answerKey);
    if (REASSESS_FRESH_QUESTIONS.some((key) => qKey.startsWith(key))) delete result[answerKey];
  });
  return result;
};

// One confirmation per screen and per care recipient (Person 1's confirmation never confirms Person 2)
export const getScreenId = (recipient: string, questions: API.Question[]) => `${recipient}/${questions?.[0]?.group}`;

export const isReassessConfirmQuestion = (questionKey: string) =>
  !REASSESS_FRESH_QUESTIONS.includes(questionKey) && !REASSESS_SKIP_CONFIRM.includes(questionKey);
